import { TermsOfService } from "@/components/common/TermsOfService";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute('/en/termsOfService')({
  component: () => TermsOfService({ pdfPath: '/TOS_SG_EN.pdf' }),
})